export default {
    carregando: false,
    items: [],
    itemsWorkflows: [],
    itemsPcoTarefas: [],
    selecionado: {},
    colunas: [],
    tarefaSelecionada: {},
    totais: {}
}